var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectSpread2");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var Collection = require('./collection');

var uuidv4 = require('uuid/v4');

var utils = require('./utils');

var _require = require('./utils'),
    getBlockHashId = _require.getBlockHashId,
    getFullBlockId = _require.getFullBlockId,
    getUrlPageId = _require.getUrlPageId;

var NOTION_BASE_URL = "https://www.notion.so";

var Notabase =
/*#__PURE__*/
function () {
  "use strict";

  function Notabase() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Notabase);

    this.utils = utils;
    this.blockStore = {};
    this.collectionSchemaStore = {};
    this.collectionStore = {};
    var proxy = options.proxy,
        token = options.token; // proxy > browser env + cloudflare worker
    // token > node env

    if (proxy) {
      var url = proxy.url,
          authCode = proxy.authCode; // browser env

      this.url = url; // cloudflare worker url
      // auth code for cloudflare worker (nobody knows but you ,same to the code that config in cf-worker)
      // without authCode you can only retrieve and cannot creat/update/delete

      this.authCode = authCode;
      this.reqeust = {
        post: function post(path, data) {
          return _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            var r;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return fetch("".concat(url).concat(path, "?body=").concat(JSON.stringify(data)), {
                      method: 'GET',
                      headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'x-auth-code': authCode // custom header

                      }
                    });

                  case 2:
                    r = _context.sent;
                    _context.next = 5;
                    return r.json();

                  case 5:
                    return _context.abrupt("return", _context.sent);

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();
        }
      };
    } else {
      // token node env 
      this.token = token;
      var tkHeader = token ? {
        'cookie': "token_v2=".concat(token)
      } : {};

      var _fetch = require("node-fetch"); // non-token browse ext env


      var credentials = !token ? {
        credentials: 'include'
      } : {};
      this.reqeust = {
        post: function post(path, data) {
          return _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2() {
            var r;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _fetch("".concat(NOTION_BASE_URL).concat(path), _objectSpread({
                      method: 'POST',
                      headers: _objectSpread({
                        'accept-encoding': 'gzip, deflate',
                        'content-length': JSON.stringify(data).length,
                        'content-type': 'application/json;charset=UTF-8',
                        'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3683.103 Safari/537.36'
                      }, tkHeader),
                      body: JSON.stringify(data)
                    }, credentials));

                  case 2:
                    r = _context2.sent;
                    _context2.next = 5;
                    return r.json();

                  case 5:
                    return _context2.abrupt("return", _context2.sent);

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }))();
        }
      };
    }
  }

  _createClass(Notabase, [{
    key: "genId",
    value: function genId() {
      return uuidv4();
    }
  }, {
    key: "searchBlocks",
    value: function () {
      var _searchBlocks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(fullTableID, query) {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.reqeust.post("/api/v3/searchBlocks", {
                  "query": query,
                  "table": "block",
                  "id": fullTableID,
                  "limit": 20
                });

              case 2:
                data = _context3.sent;
                return _context3.abrupt("return", data);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function searchBlocks(_x, _x2) {
        return _searchBlocks.apply(this, arguments);
      }

      return searchBlocks;
    }()
  }, {
    key: "getBrowseableUrlByCollectionPageId",
    value: function () {
      var _getBrowseableUrlByCollectionPageId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(pageId) {
        var r, viewId, browseableUrl;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getRecordValues([pageId], []);

              case 2:
                r = _context4.sent;
                viewId = r[0].value[pageId].view_ids[0];
                browseableUrl = "".concat(NOTION_BASE_URL).concat(getBlockHashId(pageId), "?v=").concat(getBlockHashId(viewId));
                return _context4.abrupt("return", browseableUrl);

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getBrowseableUrlByCollectionPageId(_x3) {
        return _getBrowseableUrlByCollectionPageId.apply(this, arguments);
      }

      return getBrowseableUrlByCollectionPageId;
    }()
  }, {
    key: "getRecordValues",
    value: function () {
      var _getRecordValues = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(blockIds, collectionIds) {
        var requestsIds, data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                requestsIds = [].concat(_toConsumableArray(blockIds.map(function (item) {
                  return {
                    "table": "block",
                    "id": item
                  };
                })), _toConsumableArray(collectionIds.map(function (item) {
                  return {
                    "table": "collection",
                    "id": item
                  };
                })));
                requestsIds.length > 10 ? console.log(">>>> getRecordValues: ".concat(requestsIds.length)) : console.log(">>>> getRecordValues:".concat(requestsIds));
                _context5.next = 4;
                return this.reqeust.post("/api/v3/getRecordValues", {
                  requests: requestsIds
                });

              case 4:
                data = _context5.sent;
                return _context5.abrupt("return", data.results);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getRecordValues(_x4, _x5) {
        return _getRecordValues.apply(this, arguments);
      }

      return getRecordValues;
    }()
  }, {
    key: "loadPageChunk",
    value: function () {
      var _loadPageChunk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(pageId) {
        var data;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.reqeust.post("/api/v3/loadPageChunk", {
                  "pageId": getFullBlockId(pageId),
                  "limit": 50,
                  "cursor": {
                    "stack": []
                  },
                  "chunkNumber": 0,
                  "verticalColumns": false
                });

              case 2:
                data = _context6.sent;

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function loadPageChunk(_x6) {
        return _loadPageChunk.apply(this, arguments);
      }

      return loadPageChunk;
    }()
  }, {
    key: "getPageCollectionInfo",
    value: function () {
      var _getPageCollectionInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(pageId) {
        var data, collectionId, collectionViewId;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                console.log(">>>> getPageChunk:".concat(pageId));
                _context7.next = 3;
                return this.reqeust.post("/api/v3/loadPageChunk", {
                  "pageId": getFullBlockId(pageId),
                  "limit": 50,
                  "cursor": {
                    "stack": []
                  },
                  "chunkNumber": 0,
                  "verticalColumns": false
                });

              case 3:
                data = _context7.sent;
                collectionId = Object.entries(data.recordMap.collection)[0][0];
                collectionViewId = Object.entries(data.recordMap.collection_view)[0][0];
                return _context7.abrupt("return", [collectionId, collectionViewId]);

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPageCollectionInfo(_x7) {
        return _getPageCollectionInfo.apply(this, arguments);
      }

      return getPageCollectionInfo;
    }()
  }, {
    key: "queryCollection",
    value: function () {
      var _queryCollection = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(collectionId, collectionViewId) {
        var limit,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                limit = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 980;
                _context8.next = 3;
                return this.reqeust.post("/api/v3/queryCollection", {
                  collectionId: collectionId,
                  collectionViewId: collectionViewId,
                  loader: {
                    "type": "table",
                    "limit": limit,
                    "userTimeZone": "Asia/Shanghai",
                    "userLocale": "zh-tw",
                    "loadContentCover": true
                  }
                });

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function queryCollection(_x8, _x9) {
        return _queryCollection.apply(this, arguments);
      }

      return queryCollection;
    }()
  }, {
    key: "fetchCollectionData",
    value: function () {
      var _fetchCollectionData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(collectionId, collectionViewId) {
        var limit,
            data,
            schema,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                limit = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 980;
                _context9.next = 3;
                return this.queryCollection(collectionId, collectionViewId, limit);

              case 3:
                data = _context9.sent;
                console.log(">>>> queryCollection:".concat(collectionId)); // prefetch relation  data 

                /**
                 * when limit > 1000, notion wont return recordMap. 
                 * we need use getRecordValues fetch data piece by piece
                 * 70 blocks/req 
                 * 70*14 = 980 < 1000
                 */

                schema = data.recordMap.collection[collectionId].value.schema;
                this.collectionSchemaStore[collectionId] = schema;
                _context9.next = 9;
                return new Collection(collectionId, collectionViewId, data, this);

              case 9:
                return _context9.abrupt("return", _context9.sent);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function fetchCollectionData(_x10, _x11) {
        return _fetchCollectionData.apply(this, arguments);
      }

      return fetchCollectionData;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(urlOrPageId) {
        var collectionId, collectionViewId, pageId, _ref, _ref2, _urlOrPageId$split, _urlOrPageId$split2, base, params, baseUrlList, _ref3, _ref4, r;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!urlOrPageId.match("^[a-zA-Z0-9-]+$")) {
                  _context10.next = 14;
                  break;
                }

                // pageId with '-' split
                pageId = getBlockHashId(urlOrPageId);

                if (!(pageId && pageId in this.collectionStore)) {
                  _context10.next = 6;
                  break;
                }

                return _context10.abrupt("return", this.collectionStore[pageId]);

              case 6:
                _context10.next = 8;
                return this.getPageCollectionInfo(getBlockHashId(urlOrPageId));

              case 8:
                _ref = _context10.sent;
                _ref2 = _slicedToArray(_ref, 2);
                collectionId = _ref2[0];
                collectionViewId = _ref2[1];

              case 12:
                _context10.next = 28;
                break;

              case 14:
                if (!urlOrPageId.startsWith("http")) {
                  _context10.next = 28;
                  break;
                }

                // url 
                pageId = getUrlPageId(urlOrPageId);

                if (!(pageId && pageId in this.collectionStore)) {
                  _context10.next = 20;
                  break;
                }

                return _context10.abrupt("return", this.collectionStore[pageId]);

              case 20:
                _urlOrPageId$split = urlOrPageId.split('?'), _urlOrPageId$split2 = _slicedToArray(_urlOrPageId$split, 2), base = _urlOrPageId$split2[0], params = _urlOrPageId$split2[1];
                baseUrlList = base.split('/'); // 这里需要添加分号，否则编译出错。 参见 https://www.zhihu.com/question/20298345/answer/49551142

                _context10.next = 24;
                return this.getPageCollectionInfo(baseUrlList[baseUrlList.length - 1]);

              case 24:
                _ref3 = _context10.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                collectionId = _ref4[0];
                collectionViewId = _ref4[1];

              case 28:
                _context10.next = 30;
                return this.fetchCollectionData(collectionId, collectionViewId);

              case 30:
                r = _context10.sent;
                this.collectionStore[pageId] = r;
                return _context10.abrupt("return", r);

              case 33:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function fetch(_x12) {
        return _fetch2.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "fetchAll",
    value: function () {
      var _fetchAll = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(dbMap) {
        var _this = this;

        var db, requests, res;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                db = {};
                requests = Object.entries(dbMap).map(function (item) {
                  var _item = _slicedToArray(item, 2),
                      tableName = _item[0],
                      url = _item[1];

                  db[tableName] = {};
                  return _this.fetch(url);
                });
                _context11.next = 4;
                return Promise.all(requests);

              case 4:
                res = _context11.sent;
                Object.entries(dbMap).map(function (item, index) {
                  var _item2 = _slicedToArray(item, 2),
                      tableName = _item2[0],
                      url = _item2[1];

                  db[tableName] = res[index];
                });
                return _context11.abrupt("return", db);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function fetchAll(_x13) {
        return _fetchAll.apply(this, arguments);
      }

      return fetchAll;
    }()
  }, {
    key: "fetchConfig",
    value: function () {
      var _fetchConfig = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(url, _ref5) {
        var key, value, dbMap, config;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                key = _ref5.key, value = _ref5.value;
                dbMap = {};
                _context12.next = 4;
                return this.fetch(url);

              case 4:
                config = _context12.sent;
                config.rows.map(function (r) {
                  dbMap[r[key]] = r._raw.properties[config.propsKeyMap[value].key][0][1][0][1];
                });
                return _context12.abrupt("return", dbMap);

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function fetchConfig(_x14, _x15) {
        return _fetchConfig.apply(this, arguments);
      }

      return fetchConfig;
    }()
  }]);

  return Notabase;
}();

module.exports = Notabase;